module.exports = __webpack_public_path__ + "static/img/banner4.d524f7bb.png";